import paginationHook from './usePagination';
import fetchHook from './useFetch';

export const usePagination = paginationHook;
export const useFetch = fetchHook;